import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithPwPrefix } from 'store/middleware/pwContextMiddleware';
import { WIDGET_API } from 'utils';

import type { PayHubWidgetContractsSubmitPaymentResponse } from '../models';

interface Page3dsRequest {
  pares?: string;
  cres?: string;
  md?: string;
}

export const page3dsAPI = createApi({
  reducerPath: 'page3dsAPI',
  baseQuery: createBaseQueryWithPwPrefix(WIDGET_API),
  endpoints(builder) {
    return {
      request3ds: builder.query<PayHubWidgetContractsSubmitPaymentResponse, Page3dsRequest>({
        query: (body) => ({
          url: 'payments/3ds-result',
          method: 'POST',
          body,
        }),
      }),
    };
  },
});

export const { useLazyRequest3dsQuery } = page3dsAPI;
export default page3dsAPI.reducer;
